import Skeleton from "react-loading-skeleton";
const DetailsInHorizontal = ({
  label,
  value,
  tooltip,
  loading,
  width = 250,
}) => {
  return (
    <div className={"row"}>
      <div className="col-sm-2">
        {label}
        {!!tooltip && tooltip}
      </div>
      <div className="col-sm-8 px-4 fw-bold">
        {loading ? <Skeleton width={width} /> : value}
      </div>
    </div>
  );
};

export default DetailsInHorizontal;
